export default __webpack_public_path__ + "static/media/tim_regan_dropbox-2a@2x (2).3ac6d8c0.png";